/**
 * @generated SignedSource<<3b81836048d3d809851d4182351beb59>>
 * @relayHash e90c907aaca909c587e5533d96a0f685
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c098f4ef5062f208cceff27a342a2fa314725053b4fa599555dc3e2fb569ceca

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_getIssueTransitionByIdRootQuery } from './main_getIssueTransitionByIdRootQuery.graphql';

const node: PreloadableConcreteRequest<main_getIssueTransitionByIdRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c098f4ef5062f208cceff27a342a2fa314725053b4fa599555dc3e2fb569ceca",
    "metadata": {},
    "name": "main_getIssueTransitionByIdRootQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
